import { Action, Dispatch } from 'redux'
import { FirebaseDocRefType, FirebaseTimestamp } from 'firebase/index'
import { StoreTimesale } from 'types/storeTimesale'
import { fetchStoreTimesaleAction } from 'reducks/storeTimesale/actions'
import { BreadType } from 'types/bread'

const saveStoreTimesale = (params: {
  storeRef: FirebaseDocRefType
  storeTimesale: StoreTimesale | null
  saleEndDate: string
  discountRate: string
  breads: BreadType[]
}) => {
  const { storeRef, storeTimesale, saleEndDate, discountRate, breads } = params
  return async (dispatch: Dispatch<Action>) => {
    const now = FirebaseTimestamp.now()
    const discount_rate = Number(discountRate)
    // 更新の場合
    if (storeTimesale) {
      const { ref, ...rest } = storeTimesale
      if (!ref) return
      const nextStoreTimesale: StoreTimesale = {
        ...rest,
        breads: rest.breads.map((bread) => {
          return { ...bread, discount_rate }
        }),
        is_active: true,
        has_sent_notification: false,
        end_at: FirebaseTimestamp.fromDate(new Date(saleEndDate)),
        discount_rate: 0, // 個別に割引率を設定するため
        updated_at: now,
      }
      return ref
        .set(nextStoreTimesale, { merge: true })
        .then(() => {
          nextStoreTimesale.ref = ref
          dispatch(fetchStoreTimesaleAction(nextStoreTimesale))
        })
        .catch((error: unknown) => {
          console.error(error)
        })
    } else {
      // 新規作成の場合
      const ref = storeRef.collection('store_timesales').doc()
      const nextStoreTimesale: StoreTimesale = {
        // 全商品をセール対象にする TODO 現状は当日取り置き商品のみ
        breads: breads
          .filter((bread) => bread.is_type_daily)
          .map((bread) => ({ bread_id: bread.bread_ref?.id || '', discount_rate, types: ['daily'] })),
        is_active: true,
        has_sent_notification: false,
        end_at: FirebaseTimestamp.fromDate(new Date(saleEndDate)),
        discount_rate: 0, // 個別に割引率を設定するため
        created_at: now,
        updated_at: now,
      }
      return ref
        .set(nextStoreTimesale)
        .then(() => {
          nextStoreTimesale.ref = ref
          dispatch(fetchStoreTimesaleAction(nextStoreTimesale))
        })
        .catch((error: unknown) => {
          console.error(error)
        })
    }
  }
}

export default saveStoreTimesale
